<template lang="pug">
modal.filiation-picker-finder(v-bind="$attrs" @close="$emit('close')" active title="Selecione o item de produto")
  div(slot="modal-body")
    fieldset(:disabled="loading")
      form(@submit.prevent="fetchData({page: 1})")
        .columns
          .column
            input.form-input(placeholder="Título do item de produto" v-model.trim="q.title")
          .column.col-auto
            button.btn.btn-primary.btn-action.tooltip.tooltip-left(data-tooltip="Filtrar")
              i.fas.fa-filter
    list-manager.heigt-auto(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData" hide-pagination)
      div(v-if="list")
        table.table.table-hover(v-if="list.rows.length")
          tbody
            tr.c-hand(v-for="item in list.rows" @click="$emit('select', item)")
              td
                | {{ item.title }}
                div
                  small Produto: {{ item.product.title }} 
        empty-list(v-else)

</template>

<script>
import productItems from '@/services/productItems'

export default {
  props: ['productIds'],
  data() {
    return {
      q: { title: '' },
      loading: false,
      list: null,
      error: null,
    }
  },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await productItems.listAll({
          ...params,
          take: 8,
          q: { ...this.q, productIds: this.productIds },
        })
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="stylus">
.filiation-picker-finder
  .content-full-height
    height auto
</style>
